import StringUtils from "util/StringUtils";
const streamCategoryName = (category) => StringUtils.capitalizeFirstLetter(category);
export default streamCategoryName;
